import { motion, useReducedMotion, useScroll, useTransform } from 'motion/react'
import { useRef } from 'react'
import { storeDetails } from '../content/site'
import { Reveal } from './Reveal'
import { SectionLabel } from './SectionLabel'

export function StorePresence() {
  const ref = useRef<HTMLElement>(null)
  const reduceMotion = useReducedMotion()
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start end', 'end start'] })
  const imageScale = useTransform(scrollYProgress, [0, 1], [1.04, reduceMotion ? 1.04 : 1])

  return (
    <section className="section store-section" id="store" ref={ref}>
      <div className="shell store-head">
        <SectionLabel number="04" label="Store" />
        <Reveal>
          <p className="section-kicker">Store direction</p>
          <h2>A bright, organized kiosk built for visibility.</h2>
        </Reveal>
        <Reveal className="store-intro" delay={0.06}>
          <p>
            The proposed kiosk uses clear sightlines, strong lighting and organized merchandising so a broad assortment can remain easy to browse.
          </p>
        </Reveal>
      </div>

      <motion.div
        className="store-image-wrap shell-wide media-cut"
        initial={reduceMotion ? false : { clipPath: 'polygon(0 0, 22% 0, 22% 100%, 0 100%)' }}
        whileInView={{ clipPath: 'polygon(0 0, 98% 0, 100% 3%, 100% 100%, 2% 100%, 0 97%)' }}
        viewport={{ once: true, amount: 0.16 }}
        transition={{ duration: 1.05, ease: [0.16, 1, 0.3, 1] }}
      >
        <motion.img
          style={{ scale: imageScale }}
          src="/images/bisen-kiosk-reference.jpg"
          alt="Reference mall kiosk for the proposed BISEN retail direction"
          loading="lazy"
        />
        {!reduceMotion && (
          <motion.div
            className="store-reveal-line"
            aria-hidden="true"
            initial={{ x: '-8%' }}
            whileInView={{ x: '108%' }}
            viewport={{ once: true, amount: 0.16 }}
            transition={{ duration: 1.08, ease: [0.76, 0, 0.24, 1] }}
          />
        )}
        <div className="media-stamp" aria-hidden="true">
          <span>B/</span>
          <span>Physical concept</span>
        </div>
        <div className="store-image-note">
          <span>Proposed store character</span>
          <strong>Visibility · organization · convenience</strong>
        </div>
      </motion.div>

      <div className="shell store-details">
        {storeDetails.map((detail) => (
          <div className="store-detail" key={detail.number}>
            <span>{detail.number}</span>
            <strong>{detail.title}</strong>
            <p>{detail.body}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
